// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICalculateTotalBalanceResponseDto
 */
export interface ICalculateTotalBalanceResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ICalculateTotalBalanceResponseDto
     */
    total_balance?: number;
    /**
     * 
     * @type {Set<number>}
     * @memberof ICalculateTotalBalanceResponseDto
     */
    positive_balance_account_ids?: Set<number>;
}

/**
 * Check if a given object implements the ICalculateTotalBalanceResponseDto interface.
 */
export function instanceOfICalculateTotalBalanceResponseDto(value: object): value is ICalculateTotalBalanceResponseDto {
    return true;
}

export function ICalculateTotalBalanceResponseDtoFromJSON(json: any): ICalculateTotalBalanceResponseDto {
    return ICalculateTotalBalanceResponseDtoFromJSONTyped(json, false);
}

export function ICalculateTotalBalanceResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICalculateTotalBalanceResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_balance': json['totalBalance'] == null ? undefined : json['totalBalance'],
        'positive_balance_account_ids': json['positiveBalanceAccountIds'] == null ? undefined : new Set(json['positiveBalanceAccountIds']),
    };
}

export function ICalculateTotalBalanceResponseDtoToJSON(json: any): ICalculateTotalBalanceResponseDto {
    return ICalculateTotalBalanceResponseDtoToJSONTyped(json, false);
}

export function ICalculateTotalBalanceResponseDtoToJSONTyped(value?: ICalculateTotalBalanceResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalBalance': value['total_balance'],
        'positiveBalanceAccountIds': value['positive_balance_account_ids'] == null ? undefined : Array.from(value['positive_balance_account_ids'] as Set<any>),
    };
}

